import { CommonModule, Location } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { dashboardFeature } from '@merchant-portal/app/features/dashboard/store/dashboard.reducer';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SvgLoaderModule } from '../icon/svg-loader/svg-loader/svg-loader.module';
import { MobileDetailHeaderComponent } from '../mobile-detail-header/mobile-detail-header.component';
import { SidebarStateService } from '@merchant-portal/app/services/sidebar-state.service';

interface SettingsMenuItem {
  icon: string;
  label: string;
  route: string;
  userAccess?: string;
}

@Component({
  selector: 'app-settings-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, SvgLoaderModule, MobileDetailHeaderComponent],
  templateUrl: './settings-sidebar.component.html',
  styleUrls: ['./settings-sidebar.component.scss'],
})
export class SettingsSidebarComponent implements OnInit {
  private allMenuItems: SettingsMenuItem[] = [
    {
      icon: 'user-circle.svg',
      label: 'Account',
      route: '/account-setting',
    },
    {
      icon: 'door-enter.svg',
      label: 'Audit Logs',
      route: '/activity-log',
      userAccess: 'activity-logs.view',
    },
    {
      icon: 'users-group.svg',
      label: 'Team Members',
      route: '/setting/team-members',
      userAccess: 'team-members.view',
    },
    {
      icon: 'circles.svg',
      label: 'Role & Permissions',
      route: '/setting/roles',
      userAccess: 'roles-and-permissions.view',
    },
    {
      icon: 'coins.svg',
      label: 'Deposit',
      route: '/setting/deposit',
      userAccess: 'deposit-setting.view',
    },
    {
      icon: 'bell.svg',
      label: 'Notification',
      route: '/setting/notification/transaction',
      userAccess: 'notification-settings.view',
    },
    {
      icon: 'code.svg',
      label: 'Developer Setting',
      route: '/setting/developer-setting/credentials',
      userAccess: 'developer-setting.view',
    },
    {
      icon: 'heart-handshake.svg',
      label: 'Services',
      route: '/setting/available-services',
    },
  ];

  menuItems$!: Observable<SettingsMenuItem[]>;

  constructor(private store: Store, private sidebarStateService: SidebarStateService) {}

  private router = inject(Router);

  ngOnInit() {
    this.menuItems$ = this.store.select(dashboardFeature.selectPermissionList).pipe(
      map(permissions => {
        return this.allMenuItems.filter(item => {
          // If no userAccess required, always show the item
          if (!item.userAccess) {
            return true;
          }
          // Only show if user has the required permission
          return permissions?.includes(item.userAccess) ?? false;
        });
      })
    );
  }

  onMenuClick() {
    if (this.sidebarStateService.currentState.isMobile) {
      this.sidebarStateService.setSettingsDrawerOpen(false);
    }
  }

  goBack() {
    this.sidebarStateService.setSettingsDrawerOpen(false);
    this.router.navigate(['/home']);
  }
}
